import React, { useState } from "react";
import { connect } from "react-redux";

import { selectFeaturedMan } from "../../redux/actions/featuredManufacturers";

import OptionsDialog from "./Dialogs/OptionsDialog";
import ListPageTable from "../Shared/ListPageTable";
import Search from "../Shared/Search";
import styles from '../../styles/pages/FeaturedContentPages/ProductCategory.module.css'

const FeaturedManufacturerTable = ({
  selectFeaturedMan,
  featuredManufacturer: {
    featuredManufacturers,
    selectedManufacturer,
  },
}) => {
    
  const [selectedAction, setSelectedAction] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('')

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleEditOptions = (manu, action) => {
      setSelectedAction(action);
      setDialogOpen(true);
      selectFeaturedMan(manu);
  }

  const editOptions = [
      {
          name: 'Delete',
          cb: (manu) => handleEditOptions(manu, 'delete')
      },
  ]

  const dateFormatter = new Intl.DateTimeFormat('en-us')
  const tableData = [
      {
          label:'Manufacturer',
          gridFr: 10,
          width: '200px',
          dataKey: 'generic',
          getName: manu => manu.Manufacturer?.name
          // checkSpecial: (_, index) => <div className={styles.sku_number}>Sku #{index + 1}</div>
      }, 
      {
          label:'',
          gridFr: 1,
          width: '25px',
          dataKey: 'sub-table-toggle',
      }, 
      {
          label:'',
          advancedEditOptions: editOptions,
          gridFr: 1,
          width: '25px',
          dataKey: 'advanced-edit',
          
      },
  ]

  const subTableData = [
      {
          label:'Product Name',
          gridFr: 1,
          width: '100px',
          dataKey: 'generic',
          getName: man => man.name,
      },
      {
          label:'Expiration Date',
          gridFr: 1,
          width: '80px',
          dataKey: 'generic',
          getName: (man) => man.expiration_date ? dateFormatter.format(new Date(man.expiration_date)) : 'N/A',
      },
  
      
  ]

  const getSubData = (manu) => {
      let products = []

      for (let i = 1; i < 4; i++) {
          if (manu[`product${i}`]) {
                products.push({
                  name: manu[`product${i}`].name,
                  expiration_date: manu[`expiration_date_${i}`]
              })
          }
      }
      
      return products
  }

  const getData = (featuredManufacturers) => {
    if (!searchTerm) {
      return featuredManufacturers
    }
    
    return featuredManufacturers.filter(e => e?.Manufacturer?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()))
  }

  return (
        <div className={styles.featured_page}>
          <Search
            searchProps={{
              placeholder: 'Search by Manufacturer Name',
              searchFunction: (value) => setSearchTerm(value),
              getContent: () => setSearchTerm(''),
              searchTerm,
              setSearchTerm
            }}
          />
          <ListPageTable
              tableTitle={'Featured Manufacturer Products'}
              tableKeyObjects={[
                  ...tableData
              ]}
              tableData={featuredManufacturers?.length > 0 ? getData(featuredManufacturers) : []}
              subTableKeyObject={[
                  ...subTableData
              ]}
              showSubTable={(manu) => manu.product1 || manu.product2 || manu.product3}
              subTableData={(manu) => getSubData(manu)}
              toggleSub={true}
              showOnlyOneSubTable={true}
          />
      
          <OptionsDialog
            selectedAction={selectedAction}
            open={dialogOpen}
            handleClose={handleDialogClose}
            selected={selectedManufacturer}
          />
    </div>
  );
};

const mapStateToProps = (state) => ({
  featuredManufacturer: state.featuredManufacturer,
});

export default connect(mapStateToProps, { selectFeaturedMan })(
  FeaturedManufacturerTable
);
